// extracted by mini-css-extract-plugin
export default {"screenBackground":"LoadingPage_screenBackground__mNrGF","icon":"LoadingPage_icon__AVNHg"};